import { render, staticRenderFns } from "./LabKinetics.vue?vue&type=template&id=0880d715&"
import script from "./LabKinetics.vue?vue&type=script&lang=ts&"
export * from "./LabKinetics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports